// extracted by mini-css-extract-plugin
module.exports = {"place":"place-module--place--69Ua7","typography":"place-module--typography--26RpH","ellipses":"place-module--ellipses--1iqju","followBtn":"place-module--follow-btn--3Smi1"};